// Visitor Tracking - Frontend version
// Records visitor data via backend API

import { visitorApi } from '../services/api';

const SESSION_KEY = 'visitor_session_id';

function generateSessionId(): string {
  return 'sess_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

function getSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = generateSessionId();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export async function trackPageView(pageUrl?: string, referrer?: string): Promise<void> {
  try {
    const url = pageUrl || window.location.href;
    const ref = referrer || document.referrer || '';
    
    await visitorApi.track(url, ref);
  } catch (error) {
    console.error('Failed to track page view:', error);
  }
}

export async function getVisitorStats(): Promise<any> {
  try {
    const response = await visitorApi.getStats();
    return response.data;
  } catch (error) {
    console.error('Failed to get visitor stats:', error);
    return null;
  }
}

export async function getVisitorLogs(limit: number = 100): Promise<any[]> {
  try {
    const response = await visitorApi.getLogs(limit);
    return response.data || [];
  } catch (error) {
    console.error('Failed to get visitor logs:', error);
    return [];
  }
}

export function initVisitorTracking(): void {
  getSessionId();
  trackPageView();
}

export default {
  trackPageView,
  getVisitorStats,
  getVisitorLogs,
  initVisitorTracking,
};
